var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('div',[_vm._v(" "+_vm._s(_vm.format(_vm.parse(_vm.date, 'yyyy-MM-dd 00:00:00', new Date()), 'dd.MM.yyyy'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }